import { createAction } from "redux-actions";

// ACTIONS
export const HERO_ACTIONS = {
    SET_HERO: 'hero set hero',
    GAIN_XP: 'hero gain xp',
    UPDATE_GOLD: 'hero update gold',
    LEVEL_UP: 'hero level up',
    GAIN_STRENGTH: 'hero gain strength',
    GAIN_INTELLIGENCE: 'hero gain intelligence',
    USE_ITEM: 'hero use item',
    BUY_ITEM: 'hero buy item',
    BUY_ITEM_QUANTITY: 'hero buy item quantity',
    ADD_ITEM_QUANTITY: 'hero add item quantity',
    RENAME: 'hero rename',
    MOVE: 'hero move',
    CAST_SPELL: 'hero cast spell',
    CONSUME_MANA: 'hero consume mana',
    TAKE_DAMAGE: 'hero take damage',
    ATTACK: 'hero attack',
    EQUIP_ITEM: 'hero equip item',
    UNEQUIP_ITEM: 'hero unequip item',
};

// Actions creators
export const heroActions = {
    setHero: createAction(HERO_ACTIONS.SET_HERO, (hero) => ({ hero })),
    gainXp: createAction(HERO_ACTIONS.GAIN_XP, (xp) => ({ xp })),
    updateGold: createAction(HERO_ACTIONS.UPDATE_GOLD, (gold) => ({ gold })),
    levelUp: createAction(HERO_ACTIONS.LEVEL_UP, (nextLevel, statsReducerPayload) => ({ nextLevel, statsReducerPayload })),
    gainStrength: createAction(HERO_ACTIONS.GAIN_STRENGTH, (amount) => ({ amount })),
    gainIntelligence: createAction(HERO_ACTIONS.GAIN_INTELLIGENCE, (amount) => ({ amount })),
    useItem: createAction(HERO_ACTIONS.USE_ITEM, (slotIndex) => ({ slotIndex })),
    buyItem: createAction(HERO_ACTIONS.BUY_ITEM, (idItem, quantityItem, price) => ({ idItem, quantityItem, price })),
    buyItemQuantity: createAction(HERO_ACTIONS.BUY_ITEM_QUANTITY, (slotIndex, quantity, price, idItem = null) => ({ slotIndex, quantity, price, idItem })),
    addItemQuantity: createAction(HERO_ACTIONS.ADD_ITEM_QUANTITY, (slotIndex, quantity, idItem = null) => ({ slotIndex, quantity, idItem })),
    move: createAction(HERO_ACTIONS.MOVE, (x, y) => ({ x, y })),
    rename: createAction(HERO_ACTIONS.RENAME, (name) => ({ name })),
    castSpell: createAction(HERO_ACTIONS.CAST_SPELL, (spellName, manaCost) => ({ spellName, manaCost })),
    consumeMana: createAction(HERO_ACTIONS.CONSUME_MANA, (amount) => ({ amount })),
    takeDamage: createAction(HERO_ACTIONS.TAKE_DAMAGE, (amount) => ({ amount })),
    attack: createAction(HERO_ACTIONS.ATTACK, (monsterId, attackData) => ({ monsterId, attackData })),
    equipItem: createAction(HERO_ACTIONS.EQUIP_ITEM, (slotKey) => ({ slotKey })),
    unequipItem: createAction(HERO_ACTIONS.UNEQUIP_ITEM, (slotType) => ({ slotType })),
};